var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "center",
    on: {
      "click": _vm.openTestimonialOverviewPopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f5a_icons8-opened-folder.svg"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }